;(function () {
  'use strict'

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */
  const ELEMENTS_EDIT$1 = [
    '#signupformButton',
    '.btn.btn-icon',
    '.form-module__submit .btn',
    '.learn-more-btn.btn',
    '.btn.reset',
    '.attractions-map__expand.btn',
    'p a.btn',
  ]

  const ICONS_EDIT$1 = [
    `<span class="icon">
      <svg viewBox="0 0 12 12" preserveAspectRatio="xMinYMin slice" xmlns="http://www.w3.org/2000/svg">
        <path d="m9.274 7.988-.024-6.57a.582.582 0 0 0-.58-.582h-.003L2.131.86a.581.581 0 0 0-.578.585c.001.321.26.58.58.58h.002l5.154-.018-6.946 6.99a.585.585 0 0 0 .41.995.575.575 0 0 0 .41-.17l6.932-6.977.02 5.148c.001.321.26.58.58.58h.002a.58.58 0 0 0 .577-.585z"/>
      </svg>
    </span>`,
  ]

  const SELECTOR_FORM$1 = '.footer .email-signup'
  const SELECTOR_POLICIES$1 = '.footer .email-signup .gdpr-wrap'
  const SELECTOR_ELEMENT$1 = '#attractions'

  const CLASS_NAME_SHOW$1 = 'show'
  const CLASS_NAME_SHOW$2 = 'active'

  /**
   * ------------------------------------------------------------------------
   * Functions
   * ------------------------------------------------------------------------
   */

  /**
   * movePoliciesForm - Move policies out of '.email-signup' form.
   */
  const movePoliciesForm = () => {
    let FORM_MAIL = document.querySelector(SELECTOR_FORM$1)
    let POLICIES = document.querySelector(SELECTOR_POLICIES$1)

    if (FORM_MAIL !== null && POLICIES !== null) {
      FORM_MAIL.appendChild(POLICIES)
    }
  }

  /**
   * addIcon - Add icon to element.
   */
  const addIcon = () => {
    let ATTRACTIONS = document.querySelector(SELECTOR_ELEMENT$1)
    let elements

    if (ATTRACTIONS !== null) {
      setTimeout(() => {
        ELEMENTS_EDIT$1.forEach((selector) => {
          elements = document.querySelectorAll(selector)

          elements.forEach((element) => {
            element.insertAdjacentHTML('beforeend', ICONS_EDIT$1)
          })
        })
      }, 800)
    } else {
      ELEMENTS_EDIT$1.forEach((selector) => {
        elements = document.querySelectorAll(selector)

        elements.forEach((element) => {
          element.insertAdjacentHTML('beforeend', ICONS_EDIT$1)
        })
      })
    }
  }

  /**
   * addSpan - Add span in icon to elements.
   */
  const addSpan = () => {
    let ATTRACTIONS = document.querySelector(SELECTOR_ELEMENT$1)
    let elements, text_element

    if (ATTRACTIONS !== null) {
      setTimeout(() => {
        ELEMENTS_EDIT$1.forEach((selector) => {
          elements = document.querySelectorAll(selector)

          elements.forEach((element) => {
            text_element = element.innerHTML
            element.innerHTML = '<span>' + text_element + '</span>'
          })
        })
      }, 800)
    } else {
      ELEMENTS_EDIT$1.forEach((selector) => {
        elements = document.querySelectorAll(selector)

        elements.forEach((element) => {
          text_element = element.innerHTML
          element.innerHTML = '<span>' + text_element + '</span>'
        })
      })
    }
  }

  /**
   * ------------------------------------------------------------------------
   * DOM Content Loaded is ready available
   * @param {*} callback
   * ------------------------------------------------------------------------
   */
  const onDOMLoaded = (callback) => {
    if (
      document.readyState === 'complete' ||
      document.readyState === 'interactive'
    ) {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(callback, 1)
      })
    } else {
      document.addEventListener('DOMContentLoaded', callback)
    }
  }

  onDOMLoaded(movePoliciesForm(), addIcon(), addSpan())
})()
